import {Route, } from 'react-router-dom';
import useFeature from '../FeatureProvider/useFeature';
import useUser from '../UserProvider/useUser';
import { Redirect, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { withGuard } from './GenericRouteGuard';

export function withFeatureGuard(WrappedComponent, featureName) {
  return function FeatureGuardWrapper(props) {
    const { isEnabled } = useFeature();
    return withGuard(WrappedComponent, isEnabled(featureName))(props)
  };
}

const FeatureRouteLegacy = ({ children, featureName, ...rest }) => {
    const {isEnabled} = useFeature();
    const {landingRoute} = useUser();

    return(
        <Route
            {...rest}
            render={({location}) =>
                isEnabled(featureName) ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: landingRoute(),
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    )
}

export default FeatureRouteLegacy;
